module.exports = "<iframe [src]=\"url\" class=\"asp-iframe\"></iframe>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/arianna-gledanost-emisije/arianna-gledanost-emisije.component.html
// module id = ./src/app/pages/arianna-gledanost-emisije/arianna-gledanost-emisije.component.html
// module chunks = main